import React from 'react';
import { Image as AntdImage } from 'antd';
import type { IImageProps } from './entities/IImageProps';

const BCImage: React.FC<IImageProps> & { PreviewGroup: typeof AntdImage.PreviewGroup } = (
	props: IImageProps
) => <AntdImage {...props} />;

BCImage.PreviewGroup = AntdImage.PreviewGroup;

export default BCImage;
